<template>
  <div class="products-menu">
    <label>{{ $t('root.filters.operator') }}</label>
    <select v-model='predicate'>
      <option :value='true'>{{ $t('root.filters.true') }}</option>
      <option :value='false'>{{ $t('root.filters.false') }}</option>
    </select>

    <label>{{ $t('root.filters.products') }}</label>
    <multi-select v-model='selectedProducts' :getter='getProducts' />

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
import _multi_select from '../../shared/_infinite_multi_select'

export default {
  components: {
    'multi-select': _multi_select,
  },
  data() {
    return {
      predicate: true,
      selectedProducts: [],
    }
  },
  computed: {
    selectedProductIds() {
      return this.selectedProducts.map(c => c.id)
    },
    predicateQuery() {
      return this.predicate ? 'filters[product_id_in]' : 'filters[product_id_not_in]'
    }
  },
  methods: {
    filter() {
      let newQuery = Object.assign({}, this.query)

      delete newQuery['filters[product_id_in]']
      delete newQuery['filters[product_id_not_in]']

      newQuery = Object.assign({}, newQuery, { page: 1, [this.predicateQuery]: this.selectedProductIds })

      this.$router.push({ query: newQuery })
    },
    getProducts(params) {
      return this.listStore.getProducts(params)
    }
  }
}
</script>

<style lang="sass" scoped>
.products-menu
  width: 200px
  padding: 10px
.float-right
  margin-top: 10px
select
  margin-bottom: 10px
label
  display: block
</style>
